import { Api as apiService } from '../api';
export class UsersApiService {
    static getAll() {
        return apiService.responseToJSONAndToastError(apiService.get('/api/web/users'));
    }
    static getUsersData(user_id) {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/users/info/${user_id}`));
    }
    static getCurrentUser(includes) {
        return apiService.responseToJSONAndToastError(apiService.get('/api/web/whoami', includes));
    }
    static resendMFACode() {
        return apiService.post('/api/users/resend_mfa_code');
    }
    static backupCode(payload) {
        return apiService.responseToJSONAndToastError(apiService.post('/api/users/backup_code', payload));
    }
    static setupMFA(payload) {
        return apiService.responseToJSONAndToastError(apiService.put('/api/users/mfa', payload));
    }
    static regenerateBackupCode() {
        return apiService.responseToJSONAndToastError(apiService.post('/api/users/regenerate_backup_code'));
    }
    static disableMFA() {
        return apiService.responseToJSONAndToastError(apiService.post('/api/users/disable_mfa'));
    }
    static createUsers(body) {
        return apiService.responseToJSONAndToastError(apiService.post(`/api/web/users`, body));
    }
    static update(user_id, body) {
        return apiService.responseToJSONAndToastError(apiService.put(`/api/web/users/${user_id}`, body));
    }
    static bulkResendInvite(payload) {
        return apiService.responseToJSONAndToastError(apiService.post('/api/web/users/bulk/invite/resend', payload));
    }
    static cancelBulkInvite(userIds) {
        return apiService.post('/api/web/users/bulk/invite/cancel', { user_profile_ids: userIds });
    }
}
